'use strict';

const d3 = require('d3');
const _ = require('underscore');
const IconView = require('common/ui/view/svg/icon');
const SVGView = require('common/ui/view/svg/index');
const SVGUtil = require('common/ui/view/svg/util');

const TransientButtonView = SVGView.extend({
    className: 'transient-button',

    /**
     * メニューを表示する
     *
     * @param params {Object}
     * @param params.sizeFactor {Number} - 大きさの係数, デフォルト 1
     * @param params.iconClass {String} - fontawesome icon のクラス
     * @param params.ring {Boolean} - 表示する際に波紋のリングを出すか, デフォルト false
     * @param params.pos.x {Number} - x 座標
     * @param params.pos.y {Number} - y 座標
     * @param params.scale {Number} - スケール
     */
    initialize: function(params) {
        TransientButtonView.__super__.initialize.call(this, params);
        _.bindAll(this, 'remove', 'onClick');
        this._sizeFactor = params.sizeFactor ? params.sizeFactor : 1.0;
        this._iconClass = params.iconClass;
        this._ring = params.ring ? params.ring : false;
        this._pos = params.pos;
        this._scale = params.scale;
        this._scaleFactor = 1;
        this._pos.scale = 1 / this._scale * this._scaleFactor;
    },

    render: function() {
        this.$el.attr('transform', SVGUtil.transform(this._pos));
        this.$el.on('mousedown', function() {
            d3.event.stopPropagation();
            // prevent dblclick selection
            d3.event.preventDefault();
        });
        this.$el.on('touchstart', function() {
            d3.event.stopPropagation();
            d3.event.preventDefault();
        });
        this.$el.on('mouseup', this.onClick);
        this.$el.on('touchend', this.onClick);

        if(this._ring) {
            this._renderRing();
        }

        this._renderIcon();

        setTimeout(this.remove, 2000);

        return this;
    },

    _renderIcon: function() {
        const iconSize = 16 * this._sizeFactor;
        const r = 16 * this._sizeFactor;
        const strokeWidth = 8 * this._sizeFactor;

        const g = this.$el.append('g')
            .classed('transient-button-icon', true);

        g.append('circle')
            .style('stroke-width', strokeWidth)
            .attr('r', r);

        const m = new IconView({
            class: this._iconClass,
            size: iconSize,
            offset: {x: 0, y: 0}
        });

        g.append(m.render().el);

        g.transition()
            .duration(100)
            .style('opacity', 0.8);

    },

    _renderRing: function() {
        const r = 24 * this._sizeFactor;
        const maxR = 72 * this._sizeFactor;
        const strokeWidth = 4 * this._sizeFactor;

        const c = this.$el.append('circle')
            .classed('transient-button-ring', true)
            .attr('r', r)
            .style('opacity', 0.6)
            .style('stroke-width', strokeWidth);

        c.transition()
            .duration(800)
            .style('opacity', 0)
            .attr('r', maxR)
            .remove();
    },

    remove: function() {
        this.$el.transition()
            .duration(500)
            .style('opacity', 0)
            .remove();
    },

    onClick: function() {
        this.trigger('click');
        this.$el.remove();
    },

    /**
     * メニューの見た目のサイズをスケールが変わっても同じままにするためのメソッド
     * @param scale
     */
    unzoom: function(scale) {
        if(!this._pos) {
            return;
        }

        this._scale = scale;
        const pos = this._pos;
        pos.scale = 1 / scale * this._scaleFactor;

        this.$el
            .attr('transform', SVGUtil.transform(pos))
    }
});

module.exports = TransientButtonView;



// WEBPACK FOOTER //
// ./common/ui/view/svg/transient-button.js